// Worker の汎用 API 呼び出し（Worker 経由のみ）

const API_BASE = import.meta.env.VITE_API_BASE || '';

export async function fetchMuseums() {
  const res = await fetch(`${API_BASE}/api/museums`);
  if (!res.ok) throw new Error('美術館リストの取得に失敗しました');
  const data = await res.json();
  return Array.isArray(data?.museums) ? data.museums : [];
}

export async function fetchNearby(lat, lon, radiusMeters = 3000) {
  const url = `${API_BASE}/api/nearby?lat=${lat}&lon=${lon}&radius=${radiusMeters}`;
  const res = await fetch(url);
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error || '近隣検索に失敗しました');
  }
  const data = await res.json();
  return Array.isArray(data?.items) ? data.items : [];
}

export async function translateImageApi(imageBlob) {
  const form = new FormData();
  form.append('image', imageBlob, 'capture.jpg');
  const res = await fetch(`${API_BASE}/api/translate`, { method: 'POST', body: form });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error || '翻訳に失敗しました');
  }
  return await res.json();
}

export async function extractTermsApi(narration) {
  const res = await fetch(`${API_BASE}/api/extract-terms`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ narration }),
  });
  if (!res.ok) return [];
  const data = await res.json().catch(() => ({}));
  return Array.isArray(data?.terms) ? data.terms : [];
}

export async function fetchExhibitionsApi(museumId) {
  const res = await fetch(`${API_BASE}/api/exhibitions?museumId=${encodeURIComponent(museumId)}`);
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error || '展覧会情報の取得に失敗しました');
  }
  return await res.json();
}

export async function generatePreparationApi(museumId, exhibition) {
  const res = await fetch(`${API_BASE}/api/preparation`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ museumId, exhibition }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error || '予習資料の生成に失敗しました');
  }
  return await res.json();
}

export async function compareWorksApi(works) {
  const res = await fetch(`${API_BASE}/api/compare`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ works }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error || '比較解説の生成に失敗しました');
  }
  const data = await res.json();
  return data?.comparison || '';
}

export async function askApi({ context, messages }) {
  const res = await fetch(`${API_BASE}/api/ask`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ context, messages }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error || '応答の生成に失敗しました');
  }
  const data = await res.json();
  return data?.answer || '';
}

export function getCurrentPosition(options = {}) {
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject(new Error('この端末は位置情報に対応していません'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude, accuracy: pos.coords.accuracy }),
      (err) => reject(new Error(translateGeoError(err))),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000, ...options }
    );
  });
}

function translateGeoError(err) {
  switch (err.code) {
    case err.PERMISSION_DENIED: return '位置情報の使用が許可されていません。設定から許可してください。';
    case err.POSITION_UNAVAILABLE: return '位置情報を取得できませんでした';
    case err.TIMEOUT: return '位置情報の取得がタイムアウトしました';
    default: return '位置情報の取得に失敗しました';
  }
}
